import "./threecard.css";
import dot from "../../assets/dots.svg";
const ThreeCardSection = () => {
  return (
    <section className="three-card-section" id="usecases">
      <div className="container">
        <div className="three-card-section-wrapper">
          <div className="three-card-heading">
            <div className="section-tag">
              <img src={dot} alt="resources-dots" />
              <p>Case Studies</p>
            </div>
            <h2>Trusted by Teams That Can’t Afford Downtime</h2>
            <p>
              <p>
                Discover how AgentSRE helps enterprises stay resilient under
                pressure
              </p>
            </p>
          </div>

          <div className="row three-card-wrapper">
            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
              <div className="card-wrappers">
                <div className="card-heading-div">
                  <h3>FinTech Compliance and Resilience</h3>
                </div>
                <div className="card-texts-div">
                  <p>
                    Cut MTTR by 65% while ensuring stronger PCI-DSS compliance
                    and maintaining continuous financial service availability
                  </p>
                  <div className="card-button-div">
                    <div className="arrow-div">
                      <ArrowIcon />
                    </div>
                    <p>View all</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
              <div className="card-wrappers">
                <div className="card-heading-div">
                  <h3>E-Commerce Cost Optimization</h3>
                </div>
                <div className="card-texts-div">
                  <p>
                    Reduced overall cloud costs by 22% during seasonal traffic
                    spikes customer experience
                  </p>
                  <div className="card-button-div">
                    <div className="arrow-div">
                      <ArrowIcon />
                    </div>
                    <p>View all</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
              <div className="card-wrappers">
                <div className="card-heading-div">
                  <h3>Healthcare Critical Infrastructure Uptime</h3>
                </div>
                <div className="card-texts-div">
                  <p>
                    Achieved 99.99% uptime across vital healthcare
                    infrastructure, protecting patient services ensuring
                    clinical operations
                  </p>
                  <div className="card-button-div">
                    <div className="arrow-div">
                      <ArrowIcon />
                    </div>
                    <p>View all</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.47233 8.66583H10.919L7.66566 11.9192C7.40566 12.1792 7.40566 12.6058 7.66566 12.8658C7.92566 13.1258 8.34566 13.1258 8.60566 12.8658L12.999 8.4725C13.259 8.2125 13.259 7.7925 12.999 7.5325L8.61233 3.1325C8.35233 2.8725 7.93233 2.8725 7.67233 3.1325C7.41233 3.3925 7.41233 3.8125 7.67233 4.0725L10.919 7.3325H3.47233C3.10566 7.3325 2.80566 7.6325 2.80566 7.99917C2.80566 8.36583 3.10566 8.66583 3.47233 8.66583Z"
      fill="black"
    />
  </svg>
);

export default ThreeCardSection;
